import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isCreating: false,
  errorCreating: null,
  isUpdating: false,
  errorUpdating: null,
  selected: null
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
    case Types.SHOW_EDIT_BOOKING_SYSTEM_MODAL:
      return {
        ...state,
        selected: payload
      }
    case Types.CREATE_BOOKING_SYSTEM:
      return {
        ...state,
        isCreating: true,
        errorCreating: null
      }
    case Types.CREATE_BOOKING_SYSTEM_SUCCESS:
      return {
        ...state,
        isCreating: false,
        errorCreating: null
      }
    case Types.CREATE_BOOKING_SYSTEM_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: payload
      }
    case Types.UPDATE_BOOKING_SYSTEM:
      return {
        ...state,
        isUpdating: true,
        errorUpdating: null
      }
    case Types.UPDATE_BOOKING_SYSTEM_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: null
      }
    case Types.UPDATE_BOOKING_SYSTEM_FAILED:
      return {
        ...state,
        isUpdating: false,
        errorUpdating: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/BookingSystems.js